import { useEffect } from "react"
import { TEMP_SESSION_KEY } from "shared/constants"
import "./TempSessionOverlay.scss"

const TempSessionOverlay = () => {
  const tmpTag = sessionStorage.getItem(TEMP_SESSION_KEY)
  const email = sessionStorage.getItem("temp_session_email")

  // Manage body class for spacing when temp session exists
  useEffect(() => {
    if (tmpTag) {
      // Add class when temp session exists (even if regular auth exists - admin override)
      document.body.classList.add("has-temp-session")
    } else {
      // Remove class when no temp session
      document.body.classList.remove("has-temp-session")
    }

    return () => {
      document.body.classList.remove("has-temp-session")
    }
  }, [tmpTag])

  // Only show overlay if temp session exists
  // Show it even if regular auth exists (admin override scenario)
  if (!tmpTag) {
    return null
  }

  return (
    <>
      <div className="TempSessionOverlay" />
      <div className="TempSessionMessage">
        <div className="TempSessionMessageContent">
          Logged in as {email || "User"}
        </div>
        <div className="TempSessionSpacer" />
      </div>
    </>
  )
}

TempSessionOverlay.propTypes = {}

export default TempSessionOverlay
